import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'

const basePath = 'membership/utility-expenses'

const utilityExpensesEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
({
  fetchUtilityExpenses: builder.query<any, { pageNumber?: number; pageSize?: number }>({
    query: ({ pageNumber = 0, pageSize = 10 } = {}) => ({
      url: `${basePath}?pageNumber=${pageNumber}&pageSize=${pageSize}`,
      method: 'get',
    }),
    providesTags: ['utility-expenses'],
  }),

  createUtilityExpense: builder.mutation<any, any>({
    query: (body) => ({
      url: `${basePath}/create`,
      method: 'post',
      body,
    }),
    invalidatesTags: ['utility-expenses'],
  }),

  updateUtilityExpense: builder.mutation<any, { id: number; body: any }>({
    query: ({ id, body }) => ({
      url: `${basePath}/${id}`,
      method: 'put',
      body,
    }),
    invalidatesTags: ['utility-expenses'],
  }),

  deleteUtilityExpense: builder.mutation<any, number>({
    query: (id) => ({
      url: `${basePath}/${id}`,
      method: 'delete',
    }),
    invalidatesTags: ['utility-expenses'],
  }),

  fetchUtilityExpensesReport: builder.query<any, { startDate: string; endDate: string }>({
    query: ({ startDate, endDate }) => ({
      url: `${basePath}/report?startDate=${startDate}&endDate=${endDate}`,
      method: 'get',
    }),
  }),
})

export default utilityExpensesEndpoints
